module.exports = __webpack_public_path__ + "img/Ecommerce_Set-28-512.e3f0f269.png";